/**
 * A ValidationError that can capture individual error messages for each form field
 *
 * @param {Object} fieldErrors Object containing a mapping from field names to error messages.
 * @param {message} message Optional overall message describing the error
 */
export class ValidationError extends Error {
  constructor(fieldErrors, message = 'The form is invalid') {
    super(message);

    this.fieldErrors = fieldErrors;
  }
}
